import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateShareTranscriptsEnabledMutationVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
  transcriptsEnabled?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type UpdateShareTranscriptsEnabledMutation = { __typename?: 'Mutation', updateShare?: { __typename?: 'UpdateSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, transcriptsEnabled?: boolean | null } | { __typename?: 'CollectionShare', id: string, transcriptsEnabled?: boolean | null } | null } | null };


export const UpdateShareTranscriptsEnabled = /*#__PURE__*/ gql`
    mutation UpdateShareTranscriptsEnabled($shareId: ID!, $transcriptsEnabled: Boolean) {
  updateShare(
    input: {shareId: $shareId, settings: {transcriptsEnabled: $transcriptsEnabled}}
  ) {
    share {
      id
      transcriptsEnabled
    }
  }
}
    ` as unknown as DocumentNode<UpdateShareTranscriptsEnabledMutation, UpdateShareTranscriptsEnabledMutationVariables>;

          

          export const useUpdateShareTranscriptsEnabledMutation = (options?:MutationHookOptions<UpdateShareTranscriptsEnabledMutation, UpdateShareTranscriptsEnabledMutationVariables>) => useMutation(UpdateShareTranscriptsEnabled, options);
          

          export type UpdateShareTranscriptsEnabledMutationOptions = MutationHookOptions<UpdateShareTranscriptsEnabledMutation, UpdateShareTranscriptsEnabledMutationVariables>;

          

          export type UpdateShareTranscriptsEnabledMutationResult = ReturnType<typeof useUpdateShareTranscriptsEnabledMutation>[1];

          
